module.exports = __webpack_public_path__ + "static/media/PollieRaterSocial.1d134f74.jpg";